import { render, staticRenderFns } from "./BulkFeedback.vue?vue&type=template&id=1b4bc776"
import script from "./BulkFeedback.vue?vue&type=script&lang=ts"
export * from "./BulkFeedback.vue?vue&type=script&lang=ts"
import style0 from "./BulkFeedback.vue?vue&type=style&index=0&id=1b4bc776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports